import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProjectProgramList.html?raw';
import on from 'dojo/on';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import VoiceAttributeEditForm from '../../VoiceAttributeEditForm/VoiceAttributeEditForm';
import "../../../moreCore/UI/Tabbing/PageStack";
import { HtmlHelpers, TranslationHelpers } from "../../../more/Helpers";
import EvProgramEditor from '../../EvProgram/EvProgramEditor';



interface RedEntry extends VAM2types.EvProgramEvProject {
    is_red_entry?: boolean
}
class EvProjectProgramList extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
	templateString: any = template;
    private opusInput: MdsLax<InstanceType<typeof HintBox>>;
    //private isRedEntry: CheckBox;
    private opusRedInput_Author: MdsLax<InstanceType<typeof Edit>>;
    private opusRedInput_Title: MdsLax<InstanceType<typeof Edit>>;
    private opusRedInput_Duration: MdsLax<InstanceType<typeof NumberInput>>;

    private opusInputContainer: HTMLElement;
    //private redEntryInputContainer: HTMLElement;
    private addRedEntryButton: HTMLButtonElement;
    private sectionAddEntry: HTMLElement;

    private tableContainer: HTMLElement;
    private tableContainerIndividual: HTMLElement;
    private sectionIndividual: HTMLElement;

    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.EvProgramEvProject>>>;

    private evProjectID: string;

    private entitylist_synced: Array<VAM2types.EvProgramEvProject>;
    private entitylist_individual: Array<VAM2types.EvProgramEvProject>;

    private _tableLayout: StaticTable.RowConfig = {
        "attributes": ["ID", "c_composer_author", "c_opus", "duration_min"],
        colNamesInternal: ["sync", "c_composer_author", "c_opus", "duration_min"],
        "headings": ["EvProgram_Label__SyncToEvBooking", "EvProgram_Label__AuthorComposer", "EvProgram_Label__Title","EvProgram_Label__Duration"],
        widths: ["15ch", null, null, "10ch"],
    };

    private _tableLayout_om: StaticTable.RowConfig = {
        "attributes": ["ID", "c_composer_author", "c_opus", "TXT_EvProgram_Display_cast", "duration_min"],
        colNamesInternal: ["sync", "c_composer_author", "c_opus", "TXT_EvProgram_Display_cast", "duration_min"],
        "headings": ["EvProgram_Label__SyncToEvBooking", "EvProgram_Label__AuthorComposer", "EvProgram_Label__Title", "EvProgram_Label__Instrumentation", "EvProgram_Label__Duration"],
        widths: ["15ch", null, null, null, "10ch"]
    };


    private _tableLayout_status: StaticTable.RowConfig = {
        "attributes": ["ID", "c_composer_author", "c_opus", "duration_min", "ref_ev_program_status.description"],
        colNamesInternal: ["sync", "c_composer_author", "c_opus", "duration_min", "ref_ev_program_status.description"],
        "headings": ["EvProgram_Label__SyncToEvBooking", "EvProgram_Label__AuthorComposer", "EvProgram_Label__Title", "EvProgram_Label__Duration", "General_Label_Status"],
        widths: ["15ch", null, null, "10ch", null],
        bgColors: [null, null, null, null, "ref_ev_program_status.coloration"]
    };

    private _tableLayout_om_status: StaticTable.RowConfig = {
        "attributes": ["ID", "c_composer_author", "c_opus", "TXT_EvProgram_Display_cast", "duration_min", "ref_ev_program_status.description"],
        colNamesInternal: ["sync", "c_composer_author", "c_opus", "TXT_EvProgram_Display_cast", "duration_min", "ref_ev_program_status.description"],
        "headings": ["EvProgram_Label__SyncToEvBooking", "EvProgram_Label__AuthorComposer", "EvProgram_Label__Title", "EvProgram_Label__Instrumentation", "EvProgram_Label__Duration", "General_Label_Status"],
        widths: ["15ch", null, null, null, "10ch", null],
        bgColors: [null, null, null, null, null, "ref_ev_program_status.coloration"]
    };
    private _onClick_TableRowAction(
        pEntity: any,
        rowIndex: number,
        actionType: "delete" | "edit" | "moveup" | "movedown" | "download" | "editInstrumentation",
        row: any = null,
        evt: any
    ): void {


        if (actionType == "editInstrumentation") {

            let entity = pEntity as VAM2types.EvProgram;

            let form = new VoiceAttributeEditForm();
            form.setData(entity);

            

            let dlg = new GenericDialog();
            dlg.callback = lang.hitch(this, function (form: MdsLax<InstanceType<typeof VoiceAttributeEditForm>>, rowIndex: number, result) {
                if (result <= 0) return;

                let changedData = form.getChangedData();

                //console.log("changedData", changedData);
                let modifiedEntity = lang.mixin(entity, changedData);
                //this.checkIsFormDirty();
                this.store.changeEntry(modifiedEntity);

            }, form, rowIndex);

            dlg.show(form, this.getTranslation("BookingEditor__programEditInstrumentation") + " ( " + entity.c_opus + " )", null, null, "okcancel");


            return;
        }
    }
    private _onEnableRowDeleting(entity: RedEntry, rowgroup: StaticTable.StaticTableRowGroup<RedEntry>) {
        if (entity?.is_synced_from_booking) return false;

        return true;
    }
    private _tableFormatter(cell: StaticTable.StaticTableCell<RedEntry>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;


        this.UiModder.domClass.toggle(node, "w3-text-red", !entity.ref_opus);
        
        //cell.formattingHandled = true;
        let icon = null;
        switch (colName) {
            case "sync":
                if (entity.is_synced_from_booking) {
                    cell.contentnode.innerHTML = TranslationHelpers.translate("EvCast_Label__Individual");
                    HtmlHelpers.createFontawesomeIcon("fas fa-ban", "right", cell.contentnode);
                    this.disableNode(cell.contentnode);
                    this.hideNode(cell.tableCellNode);
                } else {
                    let cb = new CheckBox();
                    cb.setType("toggle");
                    cb.setLabel("EvCast_Label__Sync");
                    cb.placeAt(cell.contentnode);
                    cb.setValue(entity.is_sync_typ_A, true);


                    if (this.hasUserRole("EvCast_Edit")) {
                        on(cb, "change", lang.hitch(this, this._onChange_SyncType, entity));
                    } else {
                        cb.setReadonly(true);
                    }
                }
                return true;
                break;

            //case "TXT_EvProgram_Display_cast":

            //    if (entity.is_red_entry || (entity as VAM2types.EvProgram).ref_opus == null) {
            //        node.innerHTML = "";
            //        //this.hideNode(cell.tableCellNode, true, true);
            //    } else {
            //        let instrumentationTooltip = new Tooltip();
            //        instrumentationTooltip.setup({
            //            content: value,
            //            targetnode: node,
            //            enableHover: true,
            //            heading: ""
            //        });

            //        let instrumentationEditIcon = this.createFontawesomeIcon("fas fa-edit hoverTxtPrimary secondaryText w3-margin-right", "&nbsp;", node);
            //        on(instrumentationEditIcon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "editInstrumentation", cell.tableRow));

            //        node.append(value);

            //        return true;
            //    }

            //    break;
           
            default:
                return false;
        }
    }

    private _tableHeaderFormatter(heading: string, colName: string, node: HTMLElement) {

        switch (colName) {
            case "sync":
                this.hideNode(node, true, true);
                return "";
                break;
        }

        return false;
    }
    private _onChange_SyncType(entity: RedEntry, isSync: boolean) {
        if (entity.is_synced_from_booking) return;

        entity.is_sync_typ_A = isSync;
        this.store.changeEntry(entity, true);
    }
    private _onChange_StoreData() {
        let diffData = this.store.getDiffData();
        let completeList = this.store.getCurrentCompleteList();

        if (!this.table) {
            this.setupTables();
        }

        //console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData);

        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }

        this._delayEmit();
    }

    private _emitHandle: any = null;
    private _delayEmit() {
        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }


        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", this.getData()), 100);

    }
    //private _onChangeIsRedEntry(): void {
    //    let isRed = this.isRedEntry.getValue();
    //    this.hideNode(this.redEntryInputContainer, !isRed);
    //    this.hideNode(this.opusInputContainer, isRed);
    //}
    private _onChangeOpusInput(): void {
        let value = this.opusInput.getValue() as VAM2types.Opus;

        if (value != null) {
            let fakeEntity: Partial<VAM2types.EvProgram> = {
                ID: (Math.random() * 100000).toString(),
                ref_opus: value,
                $Displayname: `${value.gDisp_opus} - ${value.gDisp_composer_author}`,
                c_composer_author: value.gDisp_composer_author,
                c_opus: value.opus_titel,
                duration_min: value.duration_min
            }
            
            this.store.addEntry(fakeEntity as any);

            this.opusInput.setValue(null, true);
        }
    }

    private _onChangeRedInput(value: any): void {
        let readyCheck =
            (this.opusRedInput_Title.getValue() || this.opusRedInput_Author.getValue() ) && 
            (this.opusRedInput_Duration.getValue() != null || !this.hasFeature("EvProgram/DurationIsMandatory"));

        this.disableNode(this.addRedEntryButton, !readyCheck);
    }

    private _onClickAddRedEntryButton(): void {
        this.disableNode(this.addRedEntryButton, true);       

        let fakeEntity: Partial<VAM2types.EvProgram> = {
            ID: (Math.random() * 100000).toString(),

            c_composer_author: this.opusRedInput_Author.getValue(),
            c_opus: this.opusRedInput_Title.getValue(),
            duration_min: this.opusRedInput_Duration.getValue(),
            //ref_opus: null
        }

        this.store.addEntry(fakeEntity as any);

        this.opusRedInput_Author.setValue(null, true);
        this.opusRedInput_Duration.setValue(null, true);
        this.opusRedInput_Title.setValue(null, true);
    }

    getData() {
        return this.store.getCurrentCompleteList();
    }
    getDiffData() {
        let diffData = this.store.getDiffData();
        return diffData;
    }

    private setupTables(): void {

        this.tableContainer.innerHTML = null;
        this.tableContainerIndividual.innerHTML = null;
        this.hideNode(this.sectionIndividual);

       
        this.table = new StaticTable();

        if (this.hasUserRole("EvProgram_Edit")) { 
            this.table.setupRowSorting("order");//, lang.hitch(this, this._onRowSorting));
            this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEdit))
        }
        this.table.setFormatter(lang.hitch(this, this._tableFormatter));

        if (this.hasUserRole("EvProgram_Delete")) this.table.addDefaultRowActionButton("delete", null, lang.hitch(this, this._onEnableRowDeleting));
        //this.table.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);

        if (this.hasFeature("Planning/EvProgramStatus")) this.table.addLineConfig(this.hasUserRole(["OM", "Projects_OM"]) ? this._tableLayout_om_status : this._tableLayout_status);
        else this.table.addLineConfig(this.hasUserRole(["OM", "Projects_OM"]) ? this._tableLayout_om : this._tableLayout);

        this.table.setCyAttribute("EvProjectProgramList");

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        //this.table.setData(this.entitylist);
        this.table.setupFromStore(this.store);

        // individuell:
        if (this.entitylist_individual?.length) {
            this.hideNode(this.sectionIndividual, false);

            let individualTable = new StaticTable();
            //individualTable.setLabel("EvProgram_Label__SyncedFromEvBooking");

            individualTable.addLineConfig(this._tableLayout);

            individualTable.setFormatter(lang.hitch(this, this._tableFormatter));
            individualTable.setHeadingLabelFormatter(this._tableHeaderFormatter);
            individualTable.setCyAttribute("EvProjectProgramListIndividualTable");

            individualTable.setData(this.entitylist_individual);
            individualTable.placeAt(this.tableContainerIndividual);

        }
    }  

    private _onClickEdit(data: StaticTable.StaticTableRowGroup<VAM2types.EvProgram>) {
        let programEditor = new EvProgramEditor();
        programEditor.on("confirmed", lang.hitch(this, this._onEvProgramEditorConfirmed));
        programEditor.setup(data.entity);
    }

    private _onEvProgramEditorConfirmed(program: VAM2types.EvProgram | VAM2types.EvProgramEvProject) {
        this.store.changeEntry(program as VAM2types.EvProgramEvProject, true);
    }

    private _onClick_OpenEvProgramSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvProgram_EvProject",
            lang.hitch(this, this._onCallback_Dlg)
        );

    }

    private _onCallback_Dlg(mode: string, data, items) {
        if (!items || !items.length) return;

        for (let item of items) {
            // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
            let entity = {
                ID: item.entry.value, gDisp_1: item.entry.label
            }

            if (mode == "selectEvProgram_EvProject") {
                this.opusInput.setValue(item.entry.data);
            }
                //this.previousSEDvalue = items;
        }
    }

    setup(syncedEntities: Array<VAM2types.EvProgramEvProject>, individualEntities: Array<VAM2types.EvProgramEvProject>, evProjectID: string) {
        this.store.setup(syncedEntities, "ID");
        this.evProjectID = evProjectID;
        this.entitylist_synced = syncedEntities;
        this.entitylist_individual = individualEntities;
        this.setupTables();
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.hideNode(this.sectionAddEntry, !this.hasUserRole("EvProgram_Create"));

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        this.opusInput.addInlineButton(lang.hitch(this, this._onClick_OpenEvProgramSED));

        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvProjectProgramList);